import {
  X,
  FileText,
  Users,
  Pencil,
  History,
  GitBranch,
  CheckCircle2,
  Clock,
  ChevronDown,
  ChevronUp,
  User,
  Mail,
  Eye,
  Trash2,
  LucideEye,
  EyeClosed,
  ScanEye,
  RefreshCw,
  ExternalLink,
} from 'lucide-react';
import { useState, useEffect, useCallback } from 'react';
import TemplateViewer from '../../../Pages/Template-Management/Template-Viewer/template-viewer';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import EditorModal from './editor-modal';
import AssignDrawer from './assign-drawer';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useToast } from '../../../Utils/toastContext';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { debounce } from 'lodash';
import { formatDateTimeUTC } from '../../../Constants/helper-functions';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const dummyContract = {
  id: 'CT-10293',
  name: 'Oak Residency Lease Agreement',
  status: 'Partially Signed',
  type: 'Lease Agreement',
  version: 'v3.2',
  createdAt: '10/05/2026',
  lastUpdated: '10/05/2026',
  createdBy: 'John White (Team Member)',

  contractor: {
    name: 'Michael Smith',
    email: 'michael.smith@email.com',
  },

  content: `LEASE AGREEMENT

This Lease Agreement is made between the Landlord and Tenant.

1. Property: Oak Residency, Austin TX
2. Term: 12 Months
3. Rent: $2,500/month
4. Security Deposit: $2,500
5. Terms: Standard residential lease terms apply.

(Signatures required below)`.repeat(2),

  signers: [
    {
      name: 'Alex Johnson',
      role: 'Tenant',
      status: 'signed',
      time: '2026-06-18 10:32 AM',
      email: 'alex@email.com',
    },
    {
      name: 'Priya Patel',
      role: 'Guarantor',
      status: 'pending',
      time: null,
      email: 'rpiya@email.com',
    },
    {
      name: 'Michael Smith',
      role: 'Co-Tenant',
      status: 'pending',
      time: null,
      email: 'smith@email.com',
    },
  ],

  access: [
    { name: 'John White', role: 'Creator', email: 'john@company.com' },
    { name: 'Alex Johnson', role: 'Signer', email: 'alex@email.com' },
    { name: 'Priya Patel', role: 'Viewer', email: 'priya@email.com' },
  ],

  versions: [
    { v: 'v1.0', date: '2026-06-10', by: 'Admin' },
    { v: 'v2.0', date: '2026-06-14', by: 'Manager' },
    { v: 'v3.2', date: '2026-06-18', by: 'Auto-save' },
    { v: 'v1.0', date: '2026-06-10', by: 'Admin' },
    { v: 'v2.0', date: '2026-06-14', by: 'Manager' },
    { v: 'v3.2', date: '2026-06-18', by: 'Auto-save' },
  ],
};

const PRIMARY = '#375AE7';
function TemplatePreviewModal({ template, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-3 z-50">
      <div className="bg-white w-full max-w-5xl h-[85vh] rounded-2xl shadow-xl flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="flex justify-between items-center px-5 py-3 border-b">
          <div>
            <h2 className="font-semibold text-gray-800">{template?.name}</h2>
            <p className="text-xs text-gray-500">Preview mode (read-only)</p>
          </div>

          <button onClick={onClose} className="text-gray-500 hover:text-black">
            ✕
          </button>
        </div>

        {/* PDF VIEWER AREA (placeholder) */}
        <div className="flex-1 bg-gray-100 flex items-center justify-center">
          <div className="w-full h-[50vh] md:h-[70vh] overflow-auto flex flex-col items-center">
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <div className="w-full h-full">
                <Viewer
                  className="w-full h-full rounded-md shadow-none"
                  fileUrl={template?.previewUrl}
                />
              </div>
            </Worker>
          </div>
        </div>
      </div>
    </div>
  );
}
export default function ContractDetailsFullScreen({
  onClose,
  onEdit,
  onAssign,
}) {
  // const contract = dummyContract;
  const [contract, setContract] = useState(null);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [editorContent, setEditorContent] = useState('');
  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedversionPreview, setSelectedversionPreview] = useState(null);
  const [versions, setVersions] = useState([]);
  const [historyView, setHistoryView] = useState('list');
  const navigate = useNavigate();
  const { customerId, transactionId, contractId } = useParams();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedSigner, setSelectedSigner] = useState(null);
  const [isPdfLoading, setIsPdfLoading] = useState(true);
  const location = useLocation();

  // "list" | "preview"
  const GetAPIcalls = async (url, isBlob = false) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;

    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
        throw new Error('Session expired.');
      }

      const errorData = await response.json().catch(() => ({
        message: 'Unexpected error',
      }));

      throw new Error(errorData.message);
    }

    return isBlob ? response.blob() : response.json();
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}`,
      );

      if (response.status == 200) {
        setContract(response.data.contract);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getVersionDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1//agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}/versions`,
      );

      if (response.status == 200) {
        setVersions(response.data.versions);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getpdfPreview = async () => {
    try {
      const blob = await GetAPIcalls(
        `/api/v1/agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}/preview-pdf`,
        true,
      );

      const fileURL = URL.createObjectURL(blob);

      setPdfUrl(fileURL); // ✅ save it
      setShowModal(true); // ✅ open modal
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getSelectedVersionDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1//agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}/versions/${selectedVersion.version_number}`,
      );

      if (response.status == 200) {
        setSelectedversionPreview(response.data.version);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const pad = (n) => String(n).padStart(2, '0');

    const formatted =
      `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

    return formatted;
  };

  const handleOpenSignerPreview = (signer) => {
    setSelectedSigner(signer);
    setModal('signer-signature');
  };
  const markDeleteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1//agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleDeleteContract = async () => {
    let toastMessage = null;
    try {
      const response = await markDeleteAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        navigate(`/create-contract/${customerId}/${transactionId}`);
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const [modal, setModal] = useState(null);
  // values: "preview" | "edit" | "assign" | "history" | null
  function handleSave(content) {
    // if (selectedContract) {
    //   // EDIT EXISTING
    //   setContracts((prev) =>
    //     prev.map((c) =>
    //       c.id === selectedContract.id
    //         ? {
    //             ...c,
    //             content,
    //             status: "Draft",
    //             progress: 40,
    //             updatedAt: new Date().toISOString().slice(0, 10),
    //             history: [
    //               ...c.history,
    //               {
    //                 action: "Edited",
    //                 by: "User",
    //                 time: new Date().toISOString(),
    //               },
    //             ],
    //           }
    //         : c,
    //     ),
    //   );
    // } else {
    //   // NEW CONTRACT
    //   const newContract = {
    //     id: "c" + Date.now(),
    //     name: "New Contract",
    //     template: "Custom",
    //     content,
    //     status: "Draft",
    //     progress: 30,
    //     updatedAt: new Date().toISOString().slice(0, 10),
    //     assignedUsers: [],
    //     history: [
    //       {
    //         action: "Created",
    //         by: "User",
    //         time: new Date().toISOString(),
    //       },
    //     ],
    //   };
    //   localStorage.setItem(
    //     "contract-doc",
    //     JSON.stringify({
    //       content,
    //     }),
    //   );
    //   setContracts((prev) => [newContract, ...prev]);
    //   setSelectedContract(newContract);
    // }

    setModal(null);
    getVersionDetails();
    getDetails(); // Refresh contract details after save
    getpdfPreview(); // Refresh PDF preview after save
  }

  const saveDocAPI = async (usersWithRoles) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1//agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}/reassign`;
    console.log(usersWithRoles);
    let recipient_user_ids = usersWithRoles.selectedUsers.map(
      (user) => user.user_id,
    );
    const payload = {
      message: 'Please review and sign this agreement.',
      delivery_method: 'in_app',
      signing_order: 'parallel',
      expires_days: 30,
      recipient_user_ids: recipient_user_ids,
    };
    const bodyData = payload;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  // ---------------- ASSIGN USERS ----------------
  const handleAssign = useCallback(
    debounce(async (usersWithRoles) => {
      let toastMessage = null;
      try {
        setLoading(true);
        const response = await saveDocAPI(usersWithRoles);
        if (response.status == 200) {
          showToast(response.message, 'success');
          setModal(null);
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [contractId, customerId, transactionId], // Dependencies
  );

  const postRevertAPI = async (versionNumber) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const apiUrl = `${BASE_URL}/api/v1/agent/customers/${customerId}/client-deals/${transactionId}/contracts/${contractId}/revert`;
    const bodyData = {
      version_number: versionNumber,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleRevokeVersion = useCallback(
    debounce(async (e, versionNumber) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postRevertAPI(versionNumber);
        if (response.status === 200) {
          showToast('Version revoked successfully', 'success');
          getDetails(); // Refresh contract details after revoking
          getVersionDetails(); // Refresh version details after revoking
          getpdfPreview(); // Refresh PDF preview after revoking
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedVersion, customerId, transactionId, contractId], // Dependencies
  );
  const postAgentAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant`;
    const bodyData = {
      role_id: 7, ///6 for compliance
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  // const handleRevokeVersion = async (version) => {
  //   try {
  //     // 1. Optimistic UI update
  //     // setContract((prev) => ({
  //     //   ...prev,
  //     //   versions: prev.versions.map((v) =>
  //     //     v.v === version.v
  //     //       ? {
  //     //           ...v,
  //     //           revoked: true,
  //     //           revokedAt: new Date().toISOString(),
  //     //           revokedBy: "currentUser", // replace with auth user
  //     //         }
  //     //       : v
  //     //   ),
  //     // }));

  //     // 2. API call (backend sync)
  //     const res = await fetch(`/api/contracts/${contract.id}/revoke-version`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         versionId: version.id || version.v,
  //       }),
  //     });

  //     if (!res.ok) {
  //       throw new Error("Failed to revoke version");
  //     }

  //     // 3. Optional success toast
  //     console.log("Version revoked successfully");
  //   } catch (error) {
  //     console.error(error);

  //     // 4. Rollback UI if API fails
  //     // setContract((prev) => ({
  //     //   ...prev,
  //     //   versions: prev.versions.map((v) =>
  //     //     v.v === version.v
  //     //       ? { ...v, revoked: false, revokedAt: null, revokedBy: null }
  //     //       : v
  //     //   ),
  //     // }));

  //     alert("Failed to revoke version. Please try again.");
  //   }
  // };
  useEffect(() => {
    getDetails();
    getVersionDetails();
    getpdfPreview();
  }, [contractId, transactionId, customerId]);
  useEffect(() => {
    if (selectedVersion) {
      getSelectedVersionDetails();
    }
  }, [selectedVersion]);

  console.log('selected signer', selectedSigner);
  const signatureImageUrl = (() => {
    if (!selectedSigner?.signed_fields?.length) return null;

    const signatureField = selectedSigner.signed_fields.find(
      (field) =>
        field.field_type === 'signature' &&
        field.signer_user_id === selectedSigner.user_id,
    );

    return (
      signatureField?.signature_image_url ||
      signatureField?.value || // fallback if backend changes
      null
    );
  })();

  return (
    <div className=" bg-gray-50 flex flex-col mr-4 rounded-2xl">
      {/* HEADER */}
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="sticky top-0 z-20 bg-white border-b px-4 md:px-6 py-4 flex justify-between items-center rounded-2xl">
        <div className="flex items-center gap-3">
          <FileText style={{ color: PRIMARY }} />

          <div>
            <h1 className="font-semibold text-gray-900 text-sm md:text-base">
              {contract?.title}
            </h1>
            <p className="text-xs text-gray-500">v{contract?.version_number}</p>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-4 gap-6 p-4 md:p-6 overflow-y-auto">
        {/* LEFT */}
        <div className="lg:col-span-3 space-y-5">
          {/* META */}
          <div className="bg-white rounded-xl p-4 md:p-5 shadow-sm grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
            {/* <Meta label="Type" value={contract?.type} /> */}
            <Meta
              label="Created"
              value={formatDateTimeUTC(contract?.created_at)}
            />
            <Meta
              label="Updated"
              value={formatDateTimeUTC(contract?.updated_at)}
            />
            <Meta label="Status" value={contract?.status} />
          </div>

          {/* SIGNING */}
          <div className="bg-white rounded-xl p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between gap-3">
              <div>
                <h2 className="font-semibold text-gray-900">
                  Contract Signed By
                </h2>
                <p className="text-sm text-gray-500">
                  Review each signer’s status and open their signed document
                  preview.
                </p>
              </div>
            </div>

            <div className="space-y-3">
              {contract?.signer_recipients?.length === 0 && (
                <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 p-4 text-sm text-gray-500">
                  No signers assigned to this contract.
                </div>
              )}
              {contract?.signer_recipients?.map((s, i) => {
                const signerStatus = String(
                  s?.status || 'pending',
                ).toLowerCase();
                const isSigned = [
                  'signed',
                  'completed',
                  'complete',
                  'approved',
                  'done',
                ].includes(signerStatus);
                const statusLabel = isSigned
                  ? 'Signed'
                  : signerStatus === 'viewed'
                    ? 'Viewed'
                    : 'Pending';
                const statusClasses = isSigned
                  ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                  : signerStatus === 'viewed'
                    ? 'bg-blue-50 text-blue-700 border-blue-200'
                    : 'bg-amber-50 text-amber-700 border-amber-200';

                return (
                  <div
                    key={i}
                    className="flex flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md sm:flex-row sm:items-center sm:justify-between"
                  >
                    <div className="flex min-w-0 items-center gap-3">
                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#375AE7] to-cyan-400 text-sm font-semibold text-white shadow-sm">
                        {s.name?.charAt(0) || 'U'}
                      </div>

                      <div className="min-w-0">
                        <p className="truncate text-sm font-semibold text-gray-900">
                          {s.name || 'Unnamed signer'}
                        </p>

                        {s.email && (
                          <p className="mt-1 flex items-center gap-1 truncate text-xs text-gray-400">
                            <Mail size={12} />
                            {s.email}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col items-start gap-2 sm:items-end">
                      <span
                        className={`rounded-full border px-2.5 py-1 text-[11px] font-semibold ${statusClasses}`}
                      >
                        {isSigned ? (
                          <CheckCircle2 size={12} className="mr-1 inline" />
                        ) : (
                          <Clock size={12} className="mr-1 inline" />
                        )}
                        {statusLabel}
                      </span>

                      <span className="text-xs text-gray-400">
                        {s.signed_at
                          ? formatDateTime(s.signed_at)
                          : s.viewed_at
                            ? formatDateTime(s.viewed_at)
                            : 'Awaiting'}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* PEOPLE ACCESS */}
          {/* <div className="bg-white rounded-xl p-5 shadow-sm">
            <h2 className="font-semibold mb-3">People with Access</h2>

            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
              {contract?.access?.map((p, i) => (
                <div
                  key={i}
                  className="border rounded-lg p-3 hover:shadow-sm transition"
                >
                  <div className="font-medium text-sm">{p.name}</div>

                  <div className="text-xs text-gray-500 mb-1">{p.role}</div>

                  <div className="flex items-center gap-1 text-xs text-gray-400">
                    <Mail size={12} />
                    {p.email}
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>

        {/* RIGHT ACTION PANEL */}
        <div className="lg:sticky lg:top-20 h-full">
          <div
            className="
      rounded-2xl
      border
      border-slate-200
      bg-white
      p-4
      shadow-sm
      space-y-4
    "
          >
            {/* HEADER */}
            <div
              className="
        flex
        items-center
        justify-between
        border-b
        pb-3
      "
            >
              <div>
                <h3 className="text-sm font-bold text-slate-900">
                  Contract Actions
                </h3>

                <p className="text-xs text-slate-500 mt-1">
                  Manage document workflow
                </p>
              </div>
            </div>

            <div className="space-y-3">
              {/* PREVIEW */}
              {contract?.status !== 'completed' && (
                <button
                  onClick={() => setModal('preview')}
                  className="
            group
            w-full
            flex
            items-center
            gap-3
            rounded-xl
            border
            border-slate-200
            bg-white
            px-4
            py-3
            text-sm
            font-semibold
            text-slate-700
            transition
            hover:border-blue-300
            hover:bg-blue-50/50
          "
                >
                  <div
                    className="
              h-9
              w-9
              rounded-lg
              bg-blue-50
              text-blue-600
              flex
              items-center
              justify-center
            "
                  >
                    <Eye size={17} />
                  </div>

                  <span>Preview Contract</span>
                </button>
              )}

              {/* ASSIGN USERS */}
              {contract?.status !== 'completed' && (
                <ActionButton
                  onClick={() => {
                    let redirectState = {
                      path: `/reassign-agent-contract/${customerId}/${transactionId}/${contractId}`,
                      state: {
                        from: location.pathname,
                        historyStack: [
                          ...(location.state?.historyStack || []),
                          location.pathname,
                        ],
                      },
                    };

                    sessionStorage.setItem(
                      'redirectAfterLogin',
                      JSON.stringify(redirectState),
                    );

                    navigate(
                      `/reassign-agent-contract/${customerId}/${transactionId}/${contractId}`,
                      {
                        state: redirectState.state,
                      },
                    );
                  }}
                  label="Assign Users"
                  icon={Users}
                />
              )}

              {/* DELETE */}
              {contract?.status !== 'completed' && (
                <ActionButton
                  onClick={() => setModal('delete')}
                  label="Delete Contract"
                  icon={Trash2}
                  danger
                />
              )}

              {/* SIGNED DOCUMENT */}
              {contract?.signed_pdf_url && (
                <ActionButton
                  onClick={() => setModal('signed-preview')}
                  label="Preview Signed Document"
                  icon={ScanEye}
                  success
                />
              )}

              {/* COMPLETED EMPTY STATE */}
              {contract?.status === 'completed' &&
                !contract?.signed_pdf_url && (
                  <div
                    className="
            rounded-xl
            border
            border-emerald-100
            bg-emerald-50
            p-4
            text-center
          "
                  >
                    <div
                      className="
              mx-auto
              mb-2
              h-10
              w-10
              rounded-full
              bg-emerald-100
              flex
              items-center
              justify-center
              text-emerald-600
            "
                    >
                      ✓
                    </div>

                    <p className="text-sm font-semibold text-emerald-800">
                      Contract Completed
                    </p>

                    <p className="mt-1 text-xs text-emerald-700">
                      All required actions have been completed.
                    </p>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE ACTION BAR */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t p-3 flex gap-2">
        <button onClick={onEdit} className="flex-1 py-2 rounded-lg border">
          Edit
        </button>
        <button
          onClick={onAssign}
          className="flex-1 py-2 rounded-lg text-white"
          style={{ background: PRIMARY }}
        >
          Assign
        </button>
      </div>
      {modal === 'preview' && (
        <Modal
          title={contract?.title || 'Contract preview'}
          className="max-w-6xl"
          onClose={() => setModal(null)}
        >
          <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title="PDF Preview"
                width="100%"
                height="600px"
                className="rounded-xl border border-slate-200"
              />
            ) : (
              <div className="flex h-[60vh] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 text-sm text-slate-500">
                Loading preview...
              </div>
            )}
          </div>
        </Modal>
      )}
      {modal === 'signed-preview' && (
        <Modal
          onClose={() => setModal(null)}
          title={contract?.title || 'Signed Contract'}
          className="max-w-7xl p-0 overflow-hidden rounded-3xl"
        >
          {/* 🔷 Body */}
          <div className="relative h-[85vh] bg-gradient-to-br from-slate-50 via-white to-[#EEF2FF] p-4">
            {/* 🔄 Loader Overlay */}
            {isPdfLoading && (
              <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm">
                <div className="mb-3 h-10 w-10 animate-spin rounded-full border-2 border-[#375AE7] border-t-transparent" />
                <p className="text-sm font-medium text-slate-700">
                  Loading signed document...
                </p>
              </div>
            )}

            {/* 📄 PDF Viewer */}
            {contract?.signed_pdf_url ? (
              <div className="h-full w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
                <iframe
                  src={contract?.signed_pdf_url}
                  title="Signed PDF"
                  className="h-full w-full"
                  onLoad={() => setIsPdfLoading(false)}
                />
              </div>
            ) : (
              <div className="flex h-full items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-white/60">
                <p className="text-sm text-slate-500">
                  No signed document available
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}
      {modal === 'signer-signature' && (
        <Modal
          title={
            selectedSigner
              ? `${selectedSigner.name} • Signature`
              : 'Signature preview'
          }
          className="max-w-4xl"
          onClose={() => setModal(null)}
        >
          <div className="space-y-4">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 shadow-sm">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm font-semibold text-slate-900">
                    {selectedSigner?.name || 'Signer'}
                  </p>
                  <p className="text-sm text-slate-500">
                    {selectedSigner?.role || 'Signer'}
                  </p>
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-600">
                  <span className="rounded-full border border-slate-200 bg-white px-3 py-1 font-medium">
                    {selectedSigner?.signed_at
                      ? 'Signed'
                      : selectedSigner?.viewed_at
                        ? 'Viewed'
                        : 'Pending'}
                  </span>
                  {selectedSigner?.signed_at && (
                    <span className="text-xs text-slate-400">
                      {formatDateTime(selectedSigner.signed_at)}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {signatureImageUrl ? (
              <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm">
                <img
                  src={signatureImageUrl}
                  alt={`${selectedSigner?.name || 'Signer'} signature`}
                  className="mx-auto max-h-[60vh] w-full max-w-[520px] rounded-2xl border border-slate-200 object-contain bg-slate-50 p-4"
                />
              </div>
            ) : (
              <div className="flex min-h-[48vh] flex-col items-center justify-center rounded-[24px] border border-dashed border-slate-200 bg-slate-50 px-6 text-center">
                <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm">
                  <Eye size={22} className="text-[#375AE7]" />
                </div>
                <p className="text-base font-semibold text-slate-900">
                  No signature image available yet
                </p>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-500">
                  This signer has not uploaded or shared a signature image for
                  this contract yet.
                </p>
              </div>
            )}
          </div>
        </Modal>
      )}
      {modal === 'edit' && (
        <Modal title="Edit Contract" onClose={() => setModal(null)}>
          <EditorModal
            content={editorContent}
            setContent={setEditorContent}
            onClose={() => setModal(null)}
            onSave={handleSave}
            isBlank={false}
            contract={contract}
            isEdit={true}
          />
        </Modal>
      )}
      {modal === 'edit' && (
        <Modal title="Edit Contract" onClose={() => setModal(null)}>
          <EditorModal
            content={editorContent}
            setContent={setEditorContent}
            onClose={() => setModal(null)}
            onSave={handleSave}
            isBlank={false}
            contract={contract}
            isEdit={true}
          />
        </Modal>
      )}
      {modal === 'delete' && (
        <Modal
          title="Delete Contract"
          className="max-w-lg"
          onClose={() => setModal(null)}
        >
          <div className="space-y-6">
            {/* Warning Icon */}
            <div className="flex items-center justify-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                <svg
                  className="h-8 w-8 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  />
                </svg>
              </div>
            </div>

            {/* Content */}
            <div className="text-center space-y-2">
              <h3 className="text-lg font-semibold text-gray-900">
                Are you sure you want to delete this contract?
              </h3>

              <p className="text-sm text-gray-600">
                This action cannot be undone. The contract will be permanently
                removed.
              </p>

              <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-4 text-left">
                <p className="text-sm font-medium text-gray-900">
                  {contract.title}
                </p>

                {contract.created_at && (
                  <p className="mt-1 text-xs text-gray-500">
                    Created at: {formatDateTimeUTC(contract.created_at)}
                  </p>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-center gap-3 pt-2">
              <button
                onClick={() => setModal(null)}
                className="
            rounded-xl 
            border 
            border-gray-300 
            px-5 
            py-2.5 
            text-sm 
            font-medium 
            text-gray-700
            hover:bg-gray-50
            transition
          "
              >
                Cancel
              </button>

              <button
                onClick={() => handleDeleteContract()}
                className="
            rounded-xl
            bg-red-600
            px-5
            py-2.5
            text-sm
            font-semibold
            text-white
            shadow-sm
            hover:bg-red-700
            transition
          "
              >
                Delete Contract
              </button>
            </div>
          </div>
        </Modal>
      )}
      {/* {showModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      
      <button onClick={() => setShowModal(false)}>Close</button>

      {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="PDF Preview"
          width="100%"
          height="600px"
        />
      )}

    </div>
  </div>
)} */}
      {modal === 'assign' && (
        <Modal title="Assign Users" onClose={() => setModal(null)}>
          <AssignDrawer
            contract={selectedContract}
            onClose={() => setModal(null)}
            onDone={handleAssign}
          />
        </Modal>
      )}
      {modal === 'history' && (
        <Modal
          title={
            historyView === 'list'
              ? 'Version History'
              : `Version: ${selectedversionPreview?.version_number}`
          }
          onClose={() => {
            setModal(null);
            setHistoryView('list');
            setSelectedVersion(null);
          }}
          size="md"
        >
          {/* HEADER ACTIONS */}

          {/* LIST VIEW */}
          {historyView === 'list' && (
            <div className="space-y-2 max-h-[65vh] overflow-y-auto pr-1">
              {versions.map((v, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between border rounded-xl p-3 hover:bg-slate-50 transition"
                >
                  <div>
                    <p className="font-medium text-slate-800">
                      <span className="font-normal text-slate-500">
                        Version Number:
                      </span>{' '}
                      {v.version_number}
                    </p>
                    <div className="flex gap-2 text-xs text-slate-500 mt-1">
                      <span>{formatDateTimeUTC(v.created_at)}</span>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setSelectedVersion(v);
                      setHistoryView('preview');
                    }}
                    className="px-3 py-1.5 text-xs rounded-lg bg-slate-900 text-white hover:bg-slate-700 transition"
                  >
                    View
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* PREVIEW VIEW */}
          {historyView === 'preview' &&
            selectedVersion &&
            selectedversionPreview && (
              <div className="flex flex-col h-[65vh]">
                {/* META BAR */}
                <div className="flex items-center justify-between mb-3">
                  {/* LEFT: DATE (LAST UPDATED) */}
                  <div className="flex items-center gap-2">
                    <span className="text-[10px] px-2 py-1 rounded-full bg-blue-50 text-blue-600 font-medium">
                      Last updated
                    </span>

                    <span className="text-xs text-slate-700 font-medium">
                      {formatDateTimeUTC(selectedversionPreview.created_at)}
                    </span>
                  </div>
                </div>

                {/* CONTENT */}
                <div className="flex-1 border rounded-lg bg-slate-50 overflow-auto p-4">
                  <TemplateViewer
                    version={selectedversionPreview.version_number}
                    contract={selectedversionPreview.document_content}
                  />
                </div>

                {/* ACTION FOOTER (STICKY UX STYLE) */}
                <div className="flex items-center justify-between mt-3 pt-3 border-t">
                  {/* LEFT: BACK */}
                  <button
                    onClick={() => setHistoryView('list')}
                    className="text-xs px-3 py-1.5 rounded-lg border bg-white hover:bg-slate-50 transition"
                  >
                    ← Back
                  </button>

                  {/* RIGHT: ACTIONS */}
                  <div className="flex gap-2">
                    {/* REVOKE BUTTON (DANGER) */}
                    <button
                      onClick={(e) => {
                        handleRevokeVersion(
                          e,
                          selectedversionPreview.version_number,
                        );
                        setHistoryView('list');
                        setSelectedVersion(null);
                      }}
                      className="px-3 py-1.5 text-xs rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                    >
                      Revoke Version
                    </button>
                  </div>
                </div>
              </div>
            )}
        </Modal>
      )}
    </div>
  );
}

/* HELPERS */
function Modal({ title, children, onClose, className = '' }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div
        className={`
          bg-white rounded-xl shadow-xl w-full max-w-4xl h-[80vh] flex flex-col
          ${className}
        `}
      >
        {/* Header (fixed) */}
        <div className="flex justify-between items-center p-4 border-b shrink-0">
          <h2 className="font-semibold">{title}</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body (scrollable) */}
        <div className="p-4 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
function Meta({ label, value }) {
  const getStatusStyle = (status) => {
    const normalized = String(status || '').toLowerCase();

    if (
      ['completed', 'complete', 'signed', 'approved', 'active'].includes(
        normalized,
      )
    ) {
      return {
        className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
        dot: 'bg-emerald-500',
      };
    }

    if (['pending', 'draft', 'waiting', 'sent'].includes(normalized)) {
      return {
        className: 'bg-amber-50 text-amber-700 border-amber-200',
        dot: 'bg-amber-500',
      };
    }

    if (['rejected', 'cancelled', 'failed'].includes(normalized)) {
      return {
        className: 'bg-red-50 text-red-700 border-red-200',
        dot: 'bg-red-500',
      };
    }

    if (['review', 'under_review', 'in progress'].includes(normalized)) {
      return {
        className: 'bg-blue-50 text-blue-700 border-blue-200',
        dot: 'bg-blue-500',
      };
    }

    return {
      className: 'bg-slate-50 text-slate-700 border-slate-200',
      dot: 'bg-slate-400',
    };
  };

  const isStatus = label?.toLowerCase() === 'status';

  const statusStyle = isStatus ? getStatusStyle(value) : null;

  return (
    <div className="space-y-1.5">
      <div className="text-gray-400 text-xs font-medium uppercase tracking-wide">
        {label}
      </div>

      {isStatus ? (
        <div
          className={`
            inline-flex
            items-center
            gap-2
            rounded-full
            border
            px-3
            py-1
            text-xs
            font-semibold
            capitalize
            ${statusStyle.className}
          `}
        >
          <span
            className={`
              h-2
              w-2
              rounded-full
              ${statusStyle.dot}
            `}
          />

          {value || 'Unknown'}
        </div>
      ) : (
        <div className="font-semibold text-gray-800">{value || '-'}</div>
      )}
    </div>
  );
}

function ActionButton({ label, icon: Icon, onClick, danger, success }) {
  return (
    <button
      onClick={onClick}
      className={`
        w-full
        flex
        items-center
        gap-3
        rounded-xl
        px-4
        py-3
        text-sm
        font-semibold
        transition

        ${
          danger
            ? 'border border-red-200 bg-red-50 text-red-700 hover:bg-red-100'
            : success
              ? 'border border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100'
              : 'border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-blue-300'
        }
      `}
    >
      <div
        className="
          h-9
          w-9
          rounded-lg
          bg-white
          shadow-sm
          flex
          items-center
          justify-center
        "
      >
        <Icon size={17} />
      </div>

      {label}
    </button>
  );
}
